import React from 'react';

const parentStyle = {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    borderWidth: '2px',
    borderStyle: 'solid'
};

const childStyle = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    margin: '8px'
}
const Pin = ({ borderColor = '#990000', backgroundColor = '#cccccc', glyphColor = '#990000' }) => {
    return (<React.Fragment>
            <div
                style={{
                    ...parentStyle,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                }}>
                    <div style={{
                            ...childStyle,
                            backgroundColor: glyphColor
                        }}
                    />
            </div>
        </React.Fragment>
    );
};

export default Pin;
